import { memo, useCallback, useState } from 'react';
import { useTranslation } from '@betty/i18n';
import { logError } from '@betty/toolkit/logging';
import { Button, InfoImage } from '@betty/moonlight';
import { WithdrawEmailStatusProps } from './WithdrawEmailStatus.types';
import PaymentService from '../../services/PaymentService/PaymentService';

function WithdrawEmailStatus({
  email,
  status,
  onLinkSent,
  close,
}: WithdrawEmailStatusProps) {
  const { t } = useTranslation('wallet');
  const [loading, setLoading] = useState(false);

  const onPress = useCallback(async () => {
    try {
      setLoading(true);

      await (status === 'Available'
        ? PaymentService.sendInteracEmail({ data: { email } })
        : PaymentService.resendInteracEmail({ data: { email } }));

      close();
      onLinkSent();
    } catch (error) {
      logError('Send Interac email error', error);
    } finally {
      setLoading(false);
    }
  }, [email, status, onLinkSent, close]);

  return (
    <InfoImage
      title={t(`interacEmail${status}Title`)}
      description={t(`interacEmail${status}Description`, { email })}
    >
      {status !== 'Blocked' && (
        <Button
          locNS="wallet"
          locKey={`interacEmail${status}Button`}
          size="large"
          width="100%"
          loading={loading}
          onPress={onPress}
        />
      )}
      <Button
        variant="secondary"
        locNS="common"
        locKey="close"
        size="large"
        width="100%"
        onPress={close}
      />
    </InfoImage>
  );
}

export default memo(WithdrawEmailStatus);
